import React, { FC } from "react";
import { CategorizationWithConfig } from "../../../../configMap/interfaces/category";
import useFixedMetadataCategorization from "../../../hooks/useFixedMetadataCategorization";
import CategorizationUI from "./CategorizationUI";

type Props = {
  disabled: boolean;
  categorizationWithConfig: CategorizationWithConfig;
  index: number;
  groupBlockId?: string;
};

const FixedCategorizationWrapper: FC<Props> = ({
  disabled,
  categorizationWithConfig,
  index,
  groupBlockId,
}) => {
  const {
    tabId,
    selectedCategory,
    categorizationOptions,
    handleChange,
    handleSearch,
    handleFilter,
    status,
    isCategorizationDisabledByParent,
    disabledParentTooltip,
    callEvents,
    isCategorizationLoading,
    emptySearchResult,
    loading,
    isLoadingValue,
    onFocus,
    onBlur,
    className,
  } = useFixedMetadataCategorization(
    categorizationWithConfig,
    index,
    groupBlockId,
    disabled,
  );

  return (
    <CategorizationUI
      disabled={disabled}
      categorizationWithConfig={categorizationWithConfig}
      tabId={tabId}
      selectedCategory={selectedCategory}
      categorizationOptions={categorizationOptions}
      handleChange={handleChange}
      status={status}
      isCategorizationDisabledByParent={isCategorizationDisabledByParent}
      disabledParentTooltip={disabledParentTooltip}
      callEvents={callEvents}
      isCategorizationLoading={isCategorizationLoading}
      emptySearchResult={emptySearchResult}
      loading={loading}
      isLoadingValue={isLoadingValue}
      onFocus={onFocus}
      onBlur={onBlur}
      onSearch={handleSearch}
      filterOption={handleFilter}
      className={className}
    />
  );
};

export default FixedCategorizationWrapper;
